export const EXPERIENCES = '/adventures';
export const EXPERIENCES_ADD = '/adventures/add';
export const EXPERIENCES_EDIT = '/adventures/edit/:id';

export const CLIENTS_ADD = '/whoaguides/add';
export const CLIENTS_EDIT = '/whoaguides/edit/:id';
export const CLIENTS_DETAILS = '/whoaguides/details/:id';

// Admin Routes
export const ADMIN_HOME = '/admin';
export const ADMIN_LOGIN = '/admin/login';
export const ADMIN_EXPERIENCES = '/admin/adventures';
export const SAMPLE_EXPERIENCES = '/admin/sample-experience';
export const ADMIN_CLIENTS = '/admin/whoaguides';
export const APP_USERS = '/admin/users';
export const ADMIN_ADD_CLIENT = '/admin/whoaguides/add';
export const ADMIN_FORGOT_PASSWORD = '/admin/forgot-password';
export const UPDATE_PASSWORD = '/update-password';
export const ADMIN_PROFILE = '/admin/profile';
export const ADMIN_PROFILE_EDIT = '/admin/profile/edit';
export const ADMIN_CLIENT_PROFILE = '/admin/whoaguides/profile/:clientId';
export const ADMIN_CLIENT_PROFILE_EDIT = '/admin/whoaguides/profile/:clientId/edit';
export const ADMIN_SET_DEFAULT_REVENUE_SPLIT = '/admin/revenue-split/default';
export const ADMIN_SET_PROMOTIONAL_REVENEW_SPLIT = '/admin/revenue-split/promotion';
export const ADMIN_PAYMENT = '/admin/payments';

//Client Routes
export const HOME = '/';
export const CLIENT_LOGIN = '/login';
export const CLIENT_FORGOT_PASSWORD = '/forgot-password';
export const CLIENT_INVITATION_LINK_LOGIN = '/onboard/:uuid';
export const CLIENT_EXPERIENCES = '/adventures';
export const PAGE_NOT_FOUND = '*';
export const CLIENT_COMPLETE_PROFILE = '/complete-profile';
export const CLIENT_PAYMENT = '/payments';

// Expererience Routes
export const NEW_TREASURE_HUNT = '/adventures/new/treasure-hunt';
export const NEW_GUIDED_TOUR = '/adventures/new/guided-tour';

export const EDIT_EXPERIENCE = '/adventures/:experienceID/edit';
export const CLIENT_PROFILE = '/profile';
export const CLIENT_PROFILE_EDIT = '/profile/edit';

//license and agreement Routes

export const PRIVACY_POLICY = '/privacy-policy';
export const LICENSING_AGREEMENT = '/eula';

//Notification small screen Routes

export const NOTIFICATION_SM = '/notificationSm';
